import React from 'react';
import { Tooltip, Typography } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
// Helpers
import { getRefundNote, RefundTrackedOrder } from 'pages/Events/helpers';
// Styles
import styles from './OrderRefundNote.module.scss';

const { Text } = Typography;

type OrderRefundNoteProps = {
  order: RefundTrackedOrder;
  timezone?: string | null;
};

const OrderRefundNote = ({
  order,
  timezone,
}: OrderRefundNoteProps): JSX.Element | null => {
  const note = getRefundNote(order, timezone);

  if (!note) {
    return null;
  }

  if (!note.failed) {
    return (
      <Text type="secondary" className={styles.note}>
        {note.text}
      </Text>
    );
  }

  return (
    <Tooltip title={note.reason}>
      <Text type="danger" className={styles.note}>
        <WarningOutlined /> {note.text}
      </Text>
    </Tooltip>
  );
};

export default OrderRefundNote;
